import { Dispatch } from 'redux';
import jwt_decode from 'jwt-decode';
import { api } from '../../services/api';
import {
  GDPTokenDataDTO,
  TokenDataDTO,
} from '../../models/dto/AuthenticationDTO';

export const SESSION_STORAGE_TOKEN = '@LelloPortalDP:token';
export const SESSION_STORAGE_TOKEN_IMG = '@LelloPortalDP:tokenImg';
export const SESSION_STORAGE_GDP_TOKEN = '@LelloPortalDP:gdp_token';
export const SESSION_STORAGE_USER_FULLNAME = '@LelloPortalDP:fullname';
export const SESSION_STORAGE_USER_ID = '@LelloPortalDP:userId';

export const authenticationActionTypes = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  AUTH_GDP_USER: 'AUTH_GDP_USER',

  LOGOUT: 'LOGOUT',
};

export const login = (
  user: string,
  password: string,
  onSuccess: () => void,
) => async (dispatch: Dispatch) => {
  dispatch({ type: authenticationActionTypes.LOGIN_REQUEST });
  try {
    const { data } = await api.post<TokenDataDTO>('/auth/', { user, password });
    dispatch({
      type: authenticationActionTypes.LOGIN_SUCCESS,
      payload: data,
    });
    sessionStorage.setItem(SESSION_STORAGE_TOKEN, data?.token);
    onSuccess();
  } catch (error) {
    dispatch({
      type: authenticationActionTypes.LOGIN_FAILURE,
      payload: error?.response?.data,
    });
  }
};

export const authGDPUser = (accessToken: string) => async (
  dispatch: Dispatch,
) => {
  const tokenData = jwt_decode<GDPTokenDataDTO>(accessToken);

  if (tokenData) {
    sessionStorage.setItem(SESSION_STORAGE_GDP_TOKEN, accessToken);
    sessionStorage.setItem(
      SESSION_STORAGE_USER_FULLNAME,
      tokenData.nomeUsuario,
    );
    sessionStorage.setItem(
      SESSION_STORAGE_USER_ID,
      String(tokenData.idUsuario),
    );

    dispatch({
      type: authenticationActionTypes.AUTH_GDP_USER,
      payload: tokenData,
    });
  }
};

export const logout = (isSessionExpired = false) => (dispatch: Dispatch) => {
  dispatch({
    type: authenticationActionTypes.LOGOUT,
    payload: isSessionExpired,
  });
  sessionStorage.clear();
};

export const isAuthenticated = () => {
  return sessionStorage.getItem(SESSION_STORAGE_TOKEN);
};

export const isAuthenticatedFromGDP = () => {
  return sessionStorage.getItem(SESSION_STORAGE_GDP_TOKEN);
};
